import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/site.scss';

const gaMeasurementId = process.env.GATSBY_GA_MEASUREMENT_ID || 'G-FC8TMP8K3R';
let gtagLoadPromise = null;

const pagePath = (location) => `${location.pathname}${location.search}${location.hash}`;

const scheduleAnalytics = (callback) => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: 3500 });
    return;
  }

  window.setTimeout(callback, 1800);
};

const loadGtag = () => {
  if (typeof window === 'undefined' || !gaMeasurementId) return Promise.resolve(null);
  if (typeof window.gtag === 'function' && window.__transxGtagLoaded) return Promise.resolve(window.gtag);
  if (gtagLoadPromise) return gtagLoadPromise;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  if (!window.__transxGtagInitialized) {
    window.gtag('js', new Date());
    window.__transxGtagInitialized = true;
  }

  gtagLoadPromise = new Promise((resolve, reject) => {
    const src = `https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`;
    const existing = document.querySelector(`script[src="${src}"]`);

    if (existing) {
      window.__transxGtagLoaded = true;
      resolve(window.gtag);
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      window.__transxGtagLoaded = true;
      resolve(window.gtag);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  }).catch((error) => {
    gtagLoadPromise = null;
    throw error;
  });

  return gtagLoadPromise;
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined' || !gaMeasurementId) return;

  scheduleAnalytics(() => {
    loadGtag()
      .then((gtag) => {
        if (!gtag) return;
        gtag('config', gaMeasurementId, {
          page_path: pagePath(location),
        });
      })
      .catch(() => {});
  });
};
